/*
 app dependencies
 -

 lib dependencies
 - jQuery
*/

const scState = (function()
{
	//module vars
	let isLoggedIn = false;

	//reveal public vars and functions
	return {
		//vars
		isLoggedIn
	};

})();
